import { TyreBrandOutputWithoutStatus } from './tyre-brand-output-without-status.model';


export class TyreBrandSelectActiveOutput implements ITyreBrandSelectActiveOutput {
    status!: number;
    message!: string;
    data!: TyreBrandOutputWithoutStatus[];

    constructor(data?: ITyreBrandSelectActiveOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.message = _data["message"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(TyreBrandOutputWithoutStatus.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TyreBrandSelectActiveOutput {
        data = typeof data === 'object' ? data : {};
        let result = new TyreBrandSelectActiveOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ITyreBrandSelectActiveOutput {
    status: number;
    message: string;
    data: TyreBrandOutputWithoutStatus[];
}

